import ringGroupsActions from 'actions/ring_groups';
import { STATUS_TYPES, Notification } from 'dyl-components';
import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'semantic-ui-react';
import { TopPaddedControls } from 'dyl-components';

const AddRingGroupSection = ({ label, ring_strategy, onChange, onAddRingGroup, isCreatingRingGroups, onClose }) => (
    <Form>
        <Form.Group widths='equal'>
            <Form.Input
                label='Name'
                name='label'
                value={label}
                onChange={onChange}
            />
            <Form.Select
                label='Ring Strategy'
                name='ring_strategy'
                value={ring_strategy}
                onChange={onChange}
                options={[
                    { key: 'ringall', value: 'ringall', text: 'Ring All' },
                    { key: 'roundrobin', value: 'roundrobin', text: 'Round Robin' },
                ]}
            />
            <TopPaddedControls>
                {!isCreatingRingGroups && (
                    <Form.Button
                        floated='right'
                        content={'Cancel'}
                        onClick={onClose}
                    />
                )}
                <Form.Button
                    primary
                    floated='right'
                    content={'Add'}
                    onClick={onAddRingGroup}
                    loading={isCreatingRingGroups}
                />
            </TopPaddedControls>
        </Form.Group>
    </Form>
)

class AddRingGroupSectionContainer extends React.Component {
    state = {
        label: '',
        ring_strategy: 'roundrobin'
    }

    onChange = (_, { name, value }) => {
        this.setState({ [name]: value });
    }

    onAddRingGroup = () => {
        const { label, ring_strategy } = this.state;
        this.props.onAdd(this.props.domain, [{
            label,
            ring_strategy
        }]).then(() => {
            Notification.alert('Successfully added ring group!', STATUS_TYPES.SUCCESS, true);
            this.props.onReadRingGroups(this.props.domain);
            this.onClose();
        }).catch(() => {
            Notification.alert('Failed to add ring group', STATUS_TYPES.ERROR, true);
        })
    }

    onClose = () => {
        this.props.onClose();
        this.setState({ label: '', ring_strategy: 'roundrobin' });
    }

    render() {
        return (
            <AddRingGroupSection
                isCreatingRingGroups={this.props.isCreatingRingGroups}
                label={this.state.label}
                ring_strategy={this.state.ring_strategy}
                onClose={this.onClose}
                onAddRingGroup={this.onAddRingGroup}
                onChange={this.onChange}
            />
        )
    }
}

const mapStateToProps = (state) => ({
    domain: state.pbx_config.domain,
    isCreatingRingGroups: state.ring_groups.isCreatingRingGroups
})

const mapDispatchToProps = dispatch => ({
    onAdd: (domain, payload) => {
        return dispatch(ringGroupsActions.createRingGroups(payload, null, domain));
    },
    onReadRingGroups: (domain) => {
        dispatch(ringGroupsActions.readRingGroups(domain));
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(AddRingGroupSectionContainer);
